// OKTA NOTE: This file is only used in Dev / Staging post Okta.
// TLDR: Prioritize work on it accordingly, if it's not in Prod, you have more pressing matters.
import React from "react";
import { Redirect } from "react-router";
import { logOut } from "auth/actions";
import { useStore as useAuthStore } from "auth/store";
import { removeAccessToken } from "auth/utils/oktaAuth";
import { LOGIN_PATHNAME } from "core/constants";

export const LogoutView = () => {
  const { dispatch } = useAuthStore();
  dispatch(logOut());
  removeAccessToken();
  return <Redirect to={LOGIN_PATHNAME} />;
};
